/* Theme custom file */
const STYLES_ID = 'slideshow-progress-styles';

class SlideshowProgress extends HTMLElement {
  connectedCallback() {
    SlideshowProgress.injectStyles();

    this.track = this.querySelector('[data-progress-track]');
    this.fill = this.querySelector('[data-progress-fill]');

    this.scroller = null;
    this.resizeObserver = null;
    this.mutationObserver = null;
    this.bindToSlideshow();
  }

  disconnectedCallback() {
    if (this.scroller) {
      this.scroller.removeEventListener('scroll', this.handleScroll);
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
  }

  bindToSlideshow() {
    const slideshowComponent = this.closest('[role="tabpanel"]')?.querySelector('slideshow-component')
      || this.parentElement?.querySelector('slideshow-component');

    if (!slideshowComponent) return;

    const tryBind = () => {
      this.scroller = slideshowComponent.querySelector('slideshow-slides');
      if (!this.scroller) return;

      this.handleScroll = this.updateProgress.bind(this);
      this.scroller.addEventListener('scroll', this.handleScroll, { passive: true });

      this.resizeObserver = new ResizeObserver(() => this.updateProgress());
      this.resizeObserver.observe(this.scroller);

      this.updateProgress();
    };

    if (slideshowComponent.querySelector('slideshow-slides')) {
      tryBind();
    } else {
      this.mutationObserver = new MutationObserver(() => {
        if (slideshowComponent.querySelector('slideshow-slides')) {
          this.mutationObserver.disconnect();
          this.mutationObserver = null;
          tryBind();
        }
      });
      this.mutationObserver.observe(slideshowComponent, { childList: true, subtree: true });
    }
  }

  updateProgress() {
    if (!this.scroller || !this.fill) return;

    const { scrollLeft, scrollWidth, clientWidth } = this.scroller;

    if (scrollWidth <= 0) {
      this.fill.style.transform = 'scaleX(1)';
      return;
    }

    const progress = (scrollLeft + clientWidth) / scrollWidth;
    this.fill.style.transform = `scaleX(${Math.min(progress, 1)})`;
  }

  static injectStyles() {
    if (document.getElementById(STYLES_ID)) return;

    const style = document.createElement('style');
    style.id = STYLES_ID;
    style.textContent = `
      slideshow-progress {
        display: block;
      }

      slideshow-progress [data-progress-track] {
        width: 100%;
        max-width: 564px;
        height: 2px;
        background: rgb(var(--color-foreground-rgb) / 0.1);
        margin-inline: auto;
        overflow: hidden;
      }

      slideshow-progress [data-progress-fill] {
        width: 100%;
        height: 100%;
        background: var(--color-foreground);
        border-radius: 100px;
        transform: scaleX(0);
        transform-origin: left;
        transition: transform 0.15s ease-out;
      }
    `;

    document.head.appendChild(style);
  }
}

customElements.define('slideshow-progress', SlideshowProgress);
